import { useCallback, useState } from "react";

export function useWithLoading() {
  const [loading, setLoading] = useState(false);

  const withLoading = useCallback(async (exec: () => Promise<void>) => {
    try {
      setLoading(true);
      await exec();
    } finally {
      setLoading(false);
    }
  }, []);

  return {
    loading,
    withLoading,
  };
}
